
import { Component, Vue, Prop, Ref } from "vue-property-decorator"
import { namespace, Getter } from "vuex-class"

import PostComment from "./PostComment.vue"
import History from "./History.vue"
import { CaseDetails, CaseAudit } from "@/types"
const caseStore = namespace("cases")

@Component({
	components: {
		"post-comment": PostComment,
		"history": History
	}
})
export default class CaseTimeline extends Vue {
	@Ref("history-view") historyView!: HTMLDivElement;

	@Prop({ default: null })
	currentCase!: CaseDetails | null;

	@Prop({ type: Boolean, default: false })
	canCreateComments!: boolean;

	@Getter("getCaseName") caseName!: string;
	@Getter("getRecordName") recordName!: string;

	public get getCaseOrRecordName () {
		return this.currentCase?.isCase ? this.caseName : this.recordName
	}

	private scrollToHistory () {
		// We need to wait until the collapse is actually in view before scrolling to it
		setTimeout(() => {
			this.historyView.scrollIntoView({ behavior: "smooth" })
		}, 250)
	}
}
